import api from '@api';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
    activateProductsFetchFailure,
    activateProductsFetchSuccess,
    deactivateProductsFetchFailure,
    deactivateProductsFetchSuccess,
    getProductsListFetch as getProductsListFetchAction,
    getProductsListFetchFailure,
    getProductsListFetchSuccess,
    syncEansToDcixFetchFailure,
    syncEansToDcixFetchSuccess,
    syncProductsToDcixFetchFailure,
    syncProductsToDcixFetchSuccess
} from './reducer';
import { ProductsListResType } from 'src/types/productsList';
import { SelectRowType } from 'src/types/table';
import { activateProductFetch, deactivateProductFetch } from 'src/resources/productDetail/sagas';
import translate from '@translate';
import { RootStoreType } from 'src/types/store';
import { getProductsGridFetch } from '../productsGrid/reducer';

export type GetProductsListFetchParamasType = { allStock?: boolean; simple?: boolean };

const getProductsListFetchRequest = async (params?: GetProductsListFetchParamasType) => {
    const reqParams = [];
    if (params?.allStock) {
        reqParams.push('allStock=true');
    }
    if (params?.simple) {
        reqParams.push('simple=true');
    }
    let paramsString = '';
    if (reqParams.length) {
        paramsString = `?${reqParams.join('&')}`;
    }

    const res = await api('get', `api/secure/products${paramsString}`);
    return res.data;
};

function* getProductsListFetch(action: { type: string; payload?: GetProductsListFetchParamasType }) {
    try {
        const response: ProductsListResType = yield call((): any => getProductsListFetchRequest(action.payload));
        yield put(getProductsListFetchSuccess(response));
    } catch (error) {
        yield put(getProductsListFetchFailure({ error }));
    }
}

export function* getProductsListFetchWatch() {
    yield takeEvery('productsList/getProductsListFetch', getProductsListFetch);
}

function* activateProductsFetch(action: { type: string; payload: SelectRowType[] }) {
    try {
        yield all(
            action.payload.map((id: any): any =>
                call(activateProductFetch, { type: 'productDetail/activateProductFetch', payload: String(id) })
            )
        );
        yield put(
            activateProductsFetchSuccess({
                messageSuccess: { title: translate('products.message.productsActivated') }
            })
        );
        yield put(getProductsGridFetch(undefined));
    } catch (error) {
        yield put(activateProductsFetchFailure({ error }));
    }
}

export function* activateProductsFetchWatch() {
    yield takeEvery('productsList/activateProductsFetch', activateProductsFetch);
}

function* deactivateProductsFetch(action: { type: string; payload: SelectRowType[] }) {
    try {
        yield all(
            action.payload.map((id: any): any =>
                call(deactivateProductFetch, { type: 'productDetail/deactivateProductFetch', payload: String(id) })
            )
        );
        yield put(
            deactivateProductsFetchSuccess({
                messageSuccess: { title: translate('products.message.productsDeactivated') }
            })
        );
        yield put(getProductsGridFetch(undefined));
    } catch (error) {
        yield put(deactivateProductsFetchFailure({ error }));
    }
}

export function* deactivateProductsFetchWatch() {
    yield takeEvery('productsList/deactivateProductsFetch', deactivateProductsFetch);
}

const syncProductsToDcixFetchRequest = async () => {
    const res = await api('post', 'api/secure/dcix/import/provider-products');
    return res.data;
};

function* syncProductsToDcixFetch() {
    try {
        const response: { message: string } = yield call((): any => syncProductsToDcixFetchRequest());

        yield put(
            syncProductsToDcixFetchSuccess({
                messageSuccess: {
                    title: response.message
                }
            })
        );
    } catch (error) {
        yield put(syncProductsToDcixFetchFailure({ error }));
    }
}

export function* syncProductsToDcixFetchWatch() {
    yield takeEvery('productsList/syncProductsToDcixFetch', syncProductsToDcixFetch);
}

const syncEansToDcixFetchRequest = async () => {
    const res = await api('post', 'api/secure/dcix/import/provider-eans');
    return res.data;
};

function* syncEansToDcixFetch() {
    try {
        const response: { message: string } = yield call((): any => syncEansToDcixFetchRequest());
            syncEansToDcixFetchSuccess({
                messageSuccess: {
                    title: response.message
                }
            })
    } catch (error) {
        yield put(syncEansToDcixFetchFailure({ error }));
    }
}

export function* syncEansToDcixFetchWatch() {
    yield takeEvery('productsList/syncEansToDcixFetch', syncEansToDcixFetch);
}
